import { useForm } from "react-hook-form"

import styles from "./AddAdjustmentForm.module.scss"

import {
	addAdjustmentResolver,
	type AddAdjustmentFormData,
} from "@/company_admin/utils/forms/adjustment"

type AddAdjustmentFormProps = {
	onSubmit: (data: AddAdjustmentFormData) => Promise<void>
	onCancel: () => void
	isSubmitting: boolean
}

const AddAdjustmentForm = ({
	onSubmit,
	onCancel,
	isSubmitting,
}: AddAdjustmentFormProps) => {
	const {
		register,
		handleSubmit,
		formState: { errors },
	} = useForm<AddAdjustmentFormData>({
		resolver: addAdjustmentResolver,
		defaultValues: {
			amount: undefined,
			isAmountKindPayout: true,
			name: "",
			memo: "",
		},
	})

	return (
		<form className={styles.form} onSubmit={handleSubmit(onSubmit)} noValidate>
			<div className={styles.form_row}>
				<div className={styles.field}>
					<label className={styles.label}>金額</label>
					<input
						type="number"
						className={styles.input}
						placeholder="例: 1000"
						{...register("amount", { valueAsNumber: true })}
					/>
					{errors.amount && (
						<span className={styles.error}>{errors.amount.message}</span>
					)}
				</div>

				<div className={styles.field}>
					<label className={styles.label}>支払い種別</label>
					<select className={styles.select} {...register("isAmountKindPayout")}>
						<option value="true">SOUHL 振込</option>
						<option value="false">御社 支払い</option>
					</select>
					{errors.isAmountKindPayout && (
						<span className={styles.error}>
							{errors.isAmountKindPayout.message}
						</span>
					)}
				</div>

				<div className={styles.field}>
					<label className={styles.label}>調整名</label>
					<input
						type="text"
						className={styles.input}
						placeholder="例: 返金対応"
						{...register("name")}
					/>
					{errors.name && (
						<span className={styles.error}>{errors.name.message}</span>
					)}
				</div>

				<div className={styles.field}>
					<label className={styles.label}>メモ</label>
					<textarea
						className={styles.textarea}
						placeholder="任意"
						rows={2}
						{...register("memo")}
					/>
					{errors.memo && (
						<span className={styles.error}>{errors.memo.message}</span>
					)}
				</div>
			</div>

			<div className={styles.actions}>
				<button
					type="submit"
					className={styles.submit_button}
					disabled={isSubmitting}
				>
					{isSubmitting ? "追加中..." : "追加"}
				</button>
				<button
					type="button"
					className={styles.cancel_button}
					onClick={onCancel}
					disabled={isSubmitting}
				>
					キャンセル
				</button>
			</div>
		</form>
	)
}

export default AddAdjustmentForm
